/**
 * Decide se una navigazione va dirottata sulla configurazione iniziale.
 *
 * Logica pura, senza dipendenze dal router né dallo store: riceve quello che
 * serve, restituisce il nome della rotta di destinazione oppure `null`. Stesso
 * criterio di `listiniRedirectFor`, e per la stessa ragione: una guardia di
 * navigazione che si può provare da sola è una guardia che non si rompe in
 * silenzio.
 */

/** Nome della rotta che ospita la procedura. */
export const SETUP_ROUTE = "configurazione";

/**
 * @param {object} ctx
 * @param {string} ctx.routeName nome della rotta di destinazione
 * @param {boolean} ctx.authenticated se esiste una sessione valida
 * @param {{isAdmin?: boolean, companyId?: number|null}|null} ctx.user
 * @param {boolean} ctx.configured se la configurazione è già stata chiusa
 * @returns {string|null} nome della rotta su cui dirottare, oppure null
 */
export function setupRedirectFor({
  routeName,
  authenticated,
  user,
  configured,
}) {
  // Prima del login non c'è niente da configurare, e la pagina di login deve
  // restare raggiungibile.
  if (!authenticated) return null;

  if (configured) return null;

  // Evita il ciclo: chi è già a destinazione ci resta.
  if (routeName === SETUP_ROUTE) return null;

  // L'amministratore di crmstart (`companyId` nullo) non viene mai dirottato:
  // è la via di rientro quando il cliente ha risposto male. Il confronto è
  // stretto di proposito — un `companyId` assente non è un amministratore di
  // piattaforma, è una risposta incompleta, e scambiare l'una per l'altro
  // spegnerebbe il cancello per tutti in silenzio.
  if (user && user.companyId === null) return null;

  return SETUP_ROUTE;
}

export default setupRedirectFor;
